import React from "react";
import PropTypes from "prop-types";
import Button from "antd/lib/button";
import Tooltip from "@/components/Tooltip";
import CopyOutlinedIcon from "@ant-design/icons/CopyOutlined";
import { useTheme } from "@/components/ThemeProvider";
import "./CodeBlock.less";

export default function CodeBlock({ copyable, children, ...props }) {
  const { isDarkMode } = useTheme();
  const [copied, setCopied] = React.useState(null);
  const ref = React.useRef();
  const copyFeatureEnabled = copyable && document.queryCommandSupported("copy");

  React.useEffect(() => {
    let resetCopyState;
    if (copied) {
      resetCopyState = setTimeout(() => setCopied(null), 2000);
    }
    return () => clearTimeout(resetCopyState);
  }, [copied]);

  const copy = () => {
    window.getSelection().selectAllChildren(ref.current);
    try {
      const success = document.execCommand("copy");
      if (!success) throw new Error();
      setCopied("Copied!");
    } catch (err) {
      setCopied("Copy failed");
    }
    window.getSelection().removeAllRanges();
  };

  const copyButton = (
    <Tooltip title={copied || "Copy"}>
      <Button icon={<CopyOutlinedIcon />} type="dashed" size="small" onClick={copy} />
    </Tooltip>
  );

  return (
    <div className={`code-block ${isDarkMode ? 'dark-mode' : ''}`}>
      <code {...props} ref={ref}>
        {children}
      </code>
      {copyFeatureEnabled && copyButton}
    </div>
  );
}

CodeBlock.propTypes = {
  copyable: PropTypes.bool,
  children: PropTypes.node,
};

CodeBlock.defaultProps = {
  copyable: false,
  children: null,
};
